module.exports = __webpack_public_path__ + "img/hk.bc7330ec.png";